<template lang="pug"></template>

<script>
export default {
    name: 'BotaoMonitoramentoSocioambiental',
    componentOptions: {
        title: 'Monitoramento',
        actions: [
            [
                {
                    name: 'Monitoramento Socioambiental',
                    iconClass: 'lyra-icon lyra-arvore',
                    showView: false,
                    action: 'abrirMonitoramento',
                    route: 'MonitoramentoSocioambiental',
                    isNew: true,
                    nameTranslationKey:
                        'mensagens.menuLateral.monitoramentoSocioambiental'
                }
            ]
        ]
    },

    methods: {
        abrirMonitoramento() {
            if (this.$route.name !== 'MonitoramentoSocioambiental') {
                this.$router.push({ name: 'MonitoramentoSocioambiental' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
